import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import '../scss/ambassador.style.scss';
import { ambasador2 } from './images/jpg/ambasadorimages';
import { ambasadorBrand, ambasadorBrandTalk } from './images/png/icons';
import { benefitsFeatures, lookingForFeatures, partners } from '../constant/ambasador-section.constant';
import { WhyChooseInvozioSection } from './why-choose-invozio-section.component';

interface AmbassadorProps {
  title?: string;
  subtitle?: string;
}

interface FeatureItemProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  className?: string;
}

const FeatureItem: React.FC<FeatureItemProps> = ({ icon, title, description, className = 'feature-item' }) => (
  <div className={`${className} d-flex align-items-start`}>
    <div className="feature-text flex-grow-1">
      <div className="d-flex pr-2 mb-2">
        <div className="icon-container">
          <img src={icon as string} alt={`${title} icon`} className="me-2" />
        </div>
        <h3 className="feature-title px-2">{title}</h3>
      </div>
      <p className="feature-description py-3 w-75">{description}</p>
    </div>
  </div>
);

export const Ambassador: React.FC<AmbassadorProps> = ({
  title = 'AMBASSADOR_HERO_TITLE',
  subtitle = 'AMBASSADOR_HERO_SUBTITLE',
}) => {
  const { t } = useTranslation();

  return (
    <div className="ambassador-page">
      <section className="main-content">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} md={12} className='px-0'>
              <h2 className="content-title">{t(subtitle)}</h2>
            </Col>
            <Col lg={6} md={12} className='px-0'>
              <div className="content-description-ambassador">
                <p className="description-text">{t('AMBASSADOR_CONTENT_DESCRIPTION1')}</p>
                <p className="description-text">{t('AMBASSADOR_CONTENT_DESCRIPTION2')}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="partner-programs">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} md={12} className='px-0'>
              <img src={ambasadorBrandTalk} className='w-100' alt="Partner programs" />
            </Col>
            <Col lg={6} md={12} className="px-0">
              <div className="partner-content pl-sm-5 pl-0 ">
                <h2 className="Heading_h2">{t('AMBASSADOR_PARTNER_TITLE')}</h2>
                {partners.map((partner, idx) => (
                  <div className="partner-card" key={idx}>
                    <h5 className="Heading_h5">{t(partner.titleKey)}</h5>
                    <p className="partner-card-description">{t(partner.descriptionKey)}</p>
                    {partner.link ? (
                      <Button 
                        variant="primary" 
                        className="register-btn"
                        onClick={() => window.open(partner.link, '_blank')}
                      >
                        {t('AMBASSADOR_PARTNER_BUTTON')}
                      </Button>
                    ) : (
                      <Button variant="primary" className="register-btn">
                        {t('AMBASSADOR_PARTNER_BUTTON')}
                      </Button>
                    )}
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="looking-for-section">
        <Container>
          <Row>
            <Col lg={6} md={12} className="px-0">
              <div className="looking-for-content">
                <h2 className="section-title">{t('AMBASSADOR_LOOKINGFOR_TITLE')}</h2>
                <div className="features-list">
                  {lookingForFeatures.map((feature, idx) => (
                    <FeatureItem
                      key={idx}
                      icon={feature.icon}
                      title={t(feature.title)}
                      description={t(feature.description)}
                    />
                  ))}
                </div>
              </div>
            </Col>
            <Col lg={6} md={12} className="px-0 half-stretch">
              <div className="looking-for-image">
                <img src={ambasador2} alt="Looking for freelancers" className="section-image" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <div className="bg-light">
        <WhyChooseInvozioSection
          image={ambasadorBrand}
          imageAlt="Benefits for ambassadors"
          title={t('AMBASSADOR_BENEFITS_TITLE')}
          description={''}
          features={benefitsFeatures.map(feature => ({
            icon: feature.icon,
            title: t(feature.title),
            description: t(feature.description),
          }))}
          isReadMore={false}
        />
      </div>
    </div>
  );
};

export default Ambassador;
